// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_HhX","cls2":"AutoCompleteResultRow-cls2_Fg1 AutoCompleteResultRow-cls1_HhX"};